import commonConstants from "./commonConstants";

const phoneConstants = {
  ...commonConstants,
} as const;

export default phoneConstants;
